import React, { Component } from "react"
import PropTypes from "prop-types"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { map } from "lodash"
import ProjectFilterMenu from "./lead-filter-menu";
import {
  getAllProjectAction,
  getAllProjectLead
} from "../../../store/actions";
class SubmittedWorksheetLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lead: ''
    }
    
   
  }
  componentDidMount() {
    const { onGetAllProjectLead, onGetAllProject } = this.props;
    onGetAllProjectLead(localStorage.getItem('userId'));
    onGetAllProject(localStorage.getItem('userId'), localStorage.getItem('brokerId'));
  }
  render() {
    const { allleads, projects } = this.props;
    //var days = [];
    const project = [
      { title: 'Project 1', leads: [] },
      { title: 'Project 2', leads: [] }
  ];
 
  allleads?.reduce((acc, lead) => {
    if (!lead.worksheetFilledDate) return acc;
  
   
   
  }, project);
   //
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Projects | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">
            {/* Render Breadcrumbs */}

            <Row className="mb20 project-header">
              <Col lg="12">
                <Breadcrumbs
                  title={this.props.t("Project Lead")}
                  breadcrumbItem={this.props.t("Worksheet Pending")}
                />
              </Col>

              {/* <Col lg="6">

              </Col> */}
            </Row>
            <Row>
                <ProjectFilterMenu />
                
            </Row>
            <Row>
                  <Col sm="12">
                    <Card>
                         <CardBody>
                                            <Row className="toHeadingRow ">
                                             
                                            { projects.map((project,index) => 
                                                <Col sm="2" className="" key={index}>
                                                    <div className="topHeading" style={{backgroundColor:'#000000'}}>
                                                      <h4 style={{fontSize:'12px', color:'#FFFFFF'}}>{project.projectName}</h4>
                                                    </div>
                                                </Col>
                                             )} 
                                             </Row>  
                                          
                                          </CardBody>
                    </Card>
                  </Col>
                </Row>  
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

SubmittedWorksheetLead.propTypes = {

  className: PropTypes.any,
  t: PropTypes.any,
  loading:PropTypes.object,
  onGetAllProjectLead:PropTypes.func,
  allleads:PropTypes.array,
  onGetAllProject:PropTypes.func,
  projects:PropTypes.array
}

const mapStateToProps = ({ Project, leads }) => ({
  allleads: Project.allleads,
  loading: Project.loading,
  projects: Project.projects,
 
})

const mapDispatchToProps = dispatch => ({
  onGetAllProject: (agentId, brokerId) => dispatch(getAllProjectAction(agentId, brokerId)),
  onGetAllProjectLead: (agentId) => dispatch(getAllProjectLead(agentId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(SubmittedWorksheetLead)))